var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6667 71.875C66.6667 70.2 65.1833 68.75 63.5417 68.75C52.8708 68.75 13.7958 68.75 3.125 68.75C1.48333 68.75 0 70.2 0 71.875C0 73.55 1.48333 75 3.125 75H63.5417C65.1833 75 66.6667 73.55 66.6667 71.875ZM35.8208 57.7167L73.8375 19.6958C74.55 18.9833 75 17.9333 75 16.8458C75 15.8917 74.6542 14.9042 73.8333 14.0875L60.8542 1.15417C60.0833 0.383333 59.0667 0 58.0542 0C57.0417 0 56.0292 0.383333 55.2542 1.15417L17.1583 39.0833C14.7875 46.4292 10.6792 59.1792 10.3833 60.2542C10.3 60.5667 10.2625 60.8792 10.2625 61.1875C10.2625 63.1083 11.7167 64.7208 13.45 64.7208C15.5792 64.7208 17.5792 63.9333 35.8208 57.7167ZM22.1958 43.7917L31.1 52.6958L17.9 57.0542L22.1958 43.7917ZM26.175 38.9333L58.0542 7.2L67.7833 16.8958L35.9625 48.7208L26.175 38.9333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencil);
export default __webpack_public_path__ + "static/media/ic_pencil.f1f9a4b263e1efda9bc0180b2e6639f7.svg";
export { ForwardRef as ReactComponent };